import { lazy } from "react";

export { default as Home } from "./Home";
export { default as DataBrowser } from "./DataBrowser";
export { default as NotFound } from "./NotFound";
export { default as DataOverview } from "./DataOverview";
export { default as Report } from "./Report";
export { default as ShadcnTest } from "./shadcn-test/ShadcnTest";

// Lazy loaded pages (note: must be wrapped in suspense)
export const Files = lazy(() => import("files/GlobalFilesView"));
export const SmPortal = lazy(() => import("sm/StudyManagement"));
export const ResearchWorkbench = lazy(() => import("rwb/ResearchWorkbench"));
export const Cohorts = lazy(() => import("cohorts/CohortExplorer"));
export const Admin = lazy(() => import("admin/Admin"));
export const Shared = lazy(() => import("shared/Shared"));
